export default __webpack_public_path__ + "static/media/apple-icon-152x152.189194d9.png";